import _classCallCheck from "/home/runner/work/climate-change-industry/climate-change-industry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/climate-change-industry/climate-change-industry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/climate-change-industry/climate-change-industry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/climate-change-industry/climate-change-industry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/climate-change-industry/climate-change-industry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Factory } from '../Factory.js';
import { Shape } from '../Shape.js';
import { getNumberValidator } from '../Validators.js';
import { _registerNode } from '../Global.js';
export var Ellipse = /*#__PURE__*/function (_Shape) {
  _inherits(Ellipse, _Shape);

  function Ellipse() {
    _classCallCheck(this, Ellipse);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ellipse).apply(this, arguments));
  }

  _createClass(Ellipse, [{
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      var rx = this.radiusX(),
          ry = this.radiusY();
      context.beginPath();
      context.save();

      if (rx !== ry) {
        context.scale(1, ry / rx);
      }

      context.arc(0, 0, rx, 0, Math.PI * 2, false);
      context.restore();
      context.closePath();
      context.fillStrokeShape(this);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.radiusX() * 2;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.radiusY() * 2;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.radiusX(width / 2);
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      this.radiusY(height / 2);
    }
  }]);

  return Ellipse;
}(Shape);
Ellipse.prototype.className = 'Ellipse';
Ellipse.prototype._centroid = true;
Ellipse.prototype._attrsAffectingSize = ['radiusX', 'radiusY'];

_registerNode(Ellipse);

Factory.addComponentsGetterSetter(Ellipse, 'radius', ['x', 'y']);
Factory.addGetterSetter(Ellipse, 'radiusX', 0, getNumberValidator());
Factory.addGetterSetter(Ellipse, 'radiusY', 0, getNumberValidator());